import dhtmlXGridObject from './dhtmlXGridObject';
import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlxArray from './dhtmlxArray';
import dhtmlxHierarchy from './dhtmlxHierarchy';


dhtmlXGridObject.prototype._expandMonolite = function (a, u, l) {
    var e = this.parentNode;
    var v = e.parentNode;
    var o = v.grid;
    if (a || window.event) {
        if (!l && !v._expanded) {
            o.editStop();
        }
        (a || event).cancelBubble = true;
    }
    var s = o.getUserData(v.idd, "__sub_row");
    if (!o._sub_row_editor) {
        o._sub_row_editor = new eXcell_sub_row(e);
    }
    if (!s) {
        return;
    }
    if (v._expanded && !u) {
        o._sub_row_editor._setState("plus.gif", e);
        e._previous_content = v._expanded;
        o.objBox.removeChild(v._expanded);
        v._expanded = false;
        v.style.height = (v.oldHeight || 20) + "px";
        e.style.height = (v.oldHeight || 20) + "px";
        if (o._fake) {
            o._fake.rowsAr[v.idd].style.height = (v.oldHeight || 20) + "px";
            o._fake.rowsAr[v.idd].firstChild.style.height =
                (v.oldHeight || 20) + "px";
        }
        for (var h = 0; h < v.cells.length; h++) {
            v.cells[h].style.verticalAlign = "middle";
        }
        delete o._flow[v.idd];
        o._correctMonolite();
        v._expanded.ctrl = null;
    }
    else {
        if (!v._expanded && !l) {
            o._sub_row_editor._setState("minus.gif", e);
            v.oldHeight = e.offsetHeight - 4;
            var r = null;
            if (e._previous_content) {
                r = e._previous_content;
                r.ctrl = e;
                o.objBox.appendChild(r);
                o._detectHeight(r, e, parseInt(r.style.height));
            }
            else {
                r = document.createElement("DIV");
                r.ctrl = e;
                if (e._sub_row_type) {
                    o._sub_row_render[e._sub_row_type](o, r, e, s);
                }
                else {
                    r.innerHTML = s;
                }
                r.style.cssText =
                    "position:absolute; left:0px; top:0px; overflow:auto; font-family:Tahoma; font-size:8pt; margin-top:2px; margin-left:4px;";
                r.className = "dhx_sub_row";
                o.objBox.appendChild(r);
                o._detectHeight(r, e);
            }
            if (!o._flow) {
                o.attachEvent("onGridReconstructed", function () {

                    if ((this.pagingOn && !this.parentGrid) || this._srnd) {

                        this._collapsMonolite();
                    }
                    else {

                        this._correctMonolite();
                    }
                });
                o.attachEvent("onResizeEnd", function () {

                    this._correctMonolite(true);
                });
                o.attachEvent("onAfterCMove", function () {

                    this._correctMonolite(true);
                });
                o.attachEvent("onDrop", function () {

                    this._correctMonolite(true);
                });
                o.attachEvent("onBeforePageChanged", function () {

                    this._collapsMonolite();
                    return true;
                });
                o.attachEvent("onGroupStateChanged", function () {

                    this._correctMonolite();
                    return true;
                });
                o.attachEvent("onFilterEnd", function () {

                    this._collapsMonolite();
                });
                o.attachEvent("onUnGroup", function () {

                    this._collapsMonolite();
                });
                o.attachEvent("onPageChanged", function () {

                    this._collapsMonolite();
                });
                o.attachEvent("onXLE", function () {

                    this._collapsMonolite();
                });
                o.attachEvent("onClearAll", function () {

                    for (var c in this._flow) {

                        if (this._flow[c] && this._flow[c].parentNode) {

                            this._flow[c].parentNode.removeChild(this._flow[c]);
                        }
                    }

                    this._flow = [];
                });
                o.attachEvent("onEditCell", function (w, n, x) {

                    if (w !== 2 &&
                        this._flow[n] &&
                        this.cellType[x] != "ch" &&
                        this.cellType[x] != "ra") {

                        this._expandMonolite.apply(this._flow[n].ctrl.firstChild, [
                            0,
                            false,
                            true
                        ]);
                    }
                    return true;
                });
                o.attachEvent("onCellChanged", function (x, n) {

                    if (!this._flow[x]) {
                        return;
                    }

                    var w = this.cells(x, n).cell;
                    w.style.verticalAlign = "top";
                });
                o._flow = [];
            }
            o._flow[v.idd] = r;
            o._correctMonolite();
            var m = o._srdh > 30 ? 11 : 3;
            if (o.multiLine) {
                m = 0;
            }
            for (var h_1 = 0; h_1 < v.cells.length; h_1++) {
                v.cells[h_1].style.verticalAlign = "top";
            }
            if (o._fake) {
                var g = o._fake.rowsAr[v.idd];
                for (var h_2 = 0; h_2 < g.cells.length; h_2++) {
                    g.cells[h_2].style.verticalAlign = "top";
                }
            }
            v._expanded = r;
        }
    }
    if (o._ahgr) {
        o.setSizes();
    }
    if (o.parentGrid) {
        o.callEvent("onGridReconstructed", []);
    }
    o.callEvent("onSubRowOpen", [v.idd, !!v._expanded]);
};
dhtmlXGridObject.prototype._sub_row_render = {
    ajax: function (that, d, td, c) {
        d.innerHTML = "Loading...";
        dhx4.ajax.get(c, function (xml) {
            d.innerHTML = xml.xmlDoc.responseText;
            var z = xml.xmlDoc.responseText.match(/<script[^>]*>([^\f]+?)<\/script>/g);
            if (z) {
                for (var i = 0; i < z.length; i++) {
                    eval(z[i].replace(/<([\/]{0,1})s[^>]*>/g, ""));
                }
            }
            that._detectHeight(d, td);
            that._correctMonolite();
            that.setUserData(td.parentNode.idd, "__sub_row", xml.xmlDoc.responseText);
            td._sub_row_type = null;
            if (that._ahgr) {
                that.setSizes();
            }
            that.callEvent("onSubAjaxLoad", [
                td.parentNode.idd,
                xml.xmlDoc.responseText
            ]);
        });
    },
    grid: function (a, e, h, g) {
        h._sub_grid = new dhtmlXGridObject(e);
        if (a.skin_name) {
            h._sub_grid.setSkin(a.skin_name);
        }
        h._sub_grid.parentGrid = a;
        h._sub_grid.imgURL = a.imgURL;
        h._sub_grid.iconURL = a.iconURL;
        h._sub_grid.enableAutoHeight(true);
        h._sub_grid._delta_x = h._sub_grid._delta_y = null;
        h._sub_grid.attachEvent("onGridReconstructed", function () {

            a._detectHeight(e, h, h._sub_grid.objBox.scrollHeight +
                h._sub_grid.hdr.offsetHeight +
                (this.ftr ? this.ftr.offsetHeight : 0));
            a._correctMonolite();

            this.setSizes();
            if (a.parentGrid) {
                a.callEvent("onGridReconstructed", []);
            }
        });
        if (!a.callEvent("onSubGridCreated", [
            h._sub_grid,
            h.parentNode.idd,
            h._cellIndex,
            g
        ])) {
            h._sub_grid.objBox.style.overflow = "hidden";
            h._sub_row_type = null;
        }
        else {
            h._sub_grid.load(g, function () {
                a._detectHeight(e, h, h._sub_grid.objBox.scrollHeight +
                    h._sub_grid.hdr.offsetHeight +
                    (h._sub_grid.ftr ? h._sub_grid.ftr.offsetHeight : 0));
                h._sub_grid.objBox.style.overflow = "hidden";
                a._correctMonolite();
                h._sub_row_type = null;
                if (!a.callEvent("onSubGridLoaded", [
                    h._sub_grid,
                    h.parentNode.idd,
                    h._cellIndex,
                    g
                ])) {
                    return;
                }
                if (a._ahgr) {
                    a.setSizes();
                }
                if (a.parentGrid) {
                    a.callEvent("onGridReconstructed", []);
                }
            });
        }
    }
};
dhtmlXGridObject.prototype._detectHeight = function (m, n, cEl) {
    var a = n.offsetLeft + n.offsetWidth;
    m.style.left = a + "px";
    m.style.width = Math.max(0, n.parentNode.offsetWidth - a - 4) + "px";
    var c = cEl || m.scrollHeight;
    m.style.overflow = "hidden";
    m.style.height = c + "px";
    var g = n.parentNode;
    n.parentNode.style.height = (g.oldHeight || 20) + c * 1 + "px";
    n.style.height = (g.oldHeight || 20) + c * 1 + "px";
    if (this._fake) {
        var e = this._fake.rowsAr[n.parentNode.idd];
        e.style.height = (g.oldHeight || 20) + c * 1 + "px";
        e.firstChild.style.height = (g.oldHeight || 20) + c * 1 + "px";
    }
};
dhtmlXGridObject.prototype._correctMonolite = function (g) {
    if (this._in_correction) {
        return;
    }
    this._in_correction = true;
    for (var e in this._flow) {
        if (this._flow[e] && this._flow[e].tagName == "DIV") {
            if (this.rowsAr[e]) {
                if (this.rowsAr[e].style.display == "none") {
                    this.cells4(this._flow[e].ctrl).close();
                    continue;
                }
                this._flow[e].style.top =
                    this.rowsAr[e].offsetTop + (this.rowsAr[e].oldHeight || 20) + "px";
                if (g) {
                    var c = this._flow[e].ctrl.offsetLeft + this._flow[e].ctrl.offsetWidth;
                    this._flow[e].style.left = c + "px";
                    this._flow[e].style.width = this.rowsAr[e].offsetWidth - c - 4 + "px";
                }
            }
            else {
                this._flow[e].ctrl = null;
                this.objBox.removeChild(this._flow[e]);
                delete this._flow[e];
            }
        }
    }
    this._in_correction = false;
};
dhtmlXGridObject.prototype._collapsMonolite = function () {
    for (var c in this._flow) {
        if (this._flow[c] && this._flow[c].tagName == "DIV") {
            if (this.rowsAr[c]) {
                this.cells4(this._flow[c].ctrl).close();
            }
        }
    }
};
dhtmlXGridObject.prototype.getColumnCombo = function (a) {
    if (this._col_combos && this._col_combos[a]) {
        return this._col_combos[a];
    }
    if (!this._col_combos) {
        this._col_combos = [];
    }
    this._col_combos[a] = eXcell_combo.prototype.initCombo.call({ grid: this }, a);
    return this._col_combos[a];
};
dhtmlXGridObject.prototype.refreshComboColumn = function (a) {
    this.forEachRow(function (c) {

        if (this.cells(c, a).refreshCell) {

            this.cells(c, a).refreshCell();
        }
    });
};
dhtmlXGridObject.prototype.registerCList = function (a, c) {
    if (!this.clists) {
        this.clists = new Array();
    }
    if (typeof c != "object") {
        c = c.split(",");
    }
    this.clists[a] = c;
};
dhtmlXGridObject.prototype._updateTGRState = function (a) {
    if (!a.update || a.id == 0) {
        return;
    }
    if (this.rowsAr[a.id].imgTag) {
        this.rowsAr[a.id].imgTag.src = this.iconTree + a.state + ".gif";
    }
    a.update = false;
};
dhtmlXGridObject.prototype.doExpand = function (c) {
    this.editStop();
    var e = c.parentNode.parentNode.parentNode;
    var a = this._h2.get[e.idd];
    if (!this.callEvent("onOpen", [e.idd, a.state == "plus" ? -1 : 1])) {
        return;
    }
    if (a.state == "plus") {
        this.expandKids(e);
    }
    else {
        if (a.state == "minus" && !a._closeable) {
            this.collapseKids(e);
        }
    }
};
dhtmlXGridObject.prototype._createHierarchy = function () {
    if (!this._emptyLineImg) {
        this._emptyLineImg = "blank";
    }
    return new dhtmlxHierarchy({ _emptyLineImg: this._emptyLineImg });
};
dhtmlXGridObject.prototype._getOpenLenght = function (g, e) {
    var c = this._h2.get[g].childs;
    e += c.length;
    for (var a = 0; a < c.length; a++) {
        if (c[a].childs.length && c[a].state == "minus") {
            e += this._getOpenLenght(c[a].id, 0);
        }
    }
    return e;
};
dhtmlXGridObject.prototype.collapseKids = function (e) {
    var g = this._h2.get[e.idd];
    if (g.state != "minus") {
        return;
    }
    if (!this.callEvent("onOpenStart", [e.idd, 1])) {
        return;
    }
    var h = e.rowIndex;
    if (h < 0) {
        h = this.rowsCol._dhx_find(e) + 1;
    }
    this._h2.change(g.id, "state", "plus");
    this._updateTGRState(g);
    if (this._srnd || this.pagingOn) {
        this._h2_to_buff();
        this._renderSort();
    }
    else {
        var a = this._getOpenLenght(this.rowsCol[h - 1].idd, 0);
        for (var c = 0; c < a; c++) {
            this.rowsCol[h + c].parentNode.removeChild(this.rowsCol[h + c]);
        }
        this.rowsCol.splice(h, a);
    }
    this.callEvent("onGridReconstructed", []);
    this.setSizes();
    this._h2_to_buff();
    this.callEvent("onOpenEnd", [e.idd, -1]);
};
dhtmlXGridObject.prototype._massInsert = function (a, e, g, o) {
    var h = [];
    var n = window._isKHTML ? this.obj : this.obj.rows[0].parentNode;
    this._h2_to_buff();
    if (this._srnd || this.pagingOn) {
        return this._renderSort();
    }
    var m = this._getOpenLenght(a.id, 0);
    for (var l = 0; l < m; l++) {
        var c = this.render_row(g + l);
        if (e) {
            e.parentNode.insertBefore(c, e);
        }
        else {
            n.appendChild(c);
        }
        h.push(c);
    }
    this.rowsCol = new dhtmlxArray(this.rowsCol
        .slice(0, g)
        .concat(h)
        .concat(this.rowsCol.slice(g)));
    return a.childs.length + h.length;
};
dhtmlXGridObject.prototype.expandKids = function (c, h) {
    var e = this._h2.get[c.idd];
    if (!e.childs.length && !e._xml_await) {
        return;
    }
    if (e.state != "plus") {
        return;
    }
    if (!e._loading && !h) {
        if (!this.callEvent("onOpenStart", [e.id, -1])) {
            return;
        }
    }
    var g = this.getRowIndex(e.id) + 1;
    if (e.childs.length) {
        e._loading = false;
        this._h2.change(e.id, "state", "minus");
        this._updateTGRState(e);
        var a = this._massInsert(e, this.rowsCol[g], g);
        this.callEvent("onGridReconstructed", []);
    }
    else {
        if (e._xml_await) {
            e._loading = true;
            if (this.callEvent("onDynXLS", [e.id])) {
                this.load(this.kidsXmlFile +
                    "" +
                    (this.kidsXmlFile.indexOf("?") != -1 ? "&" : "?") +
                    "id=" +
                    encodeURIComponent(e.id), this._data_type);
            }
        }
    }
    this.setSizes();
    if (!e._loading) {
        this.callEvent("onOpenEnd", [e.id, 1]);
    }
    this._fixAlterCss();
};
dhtmlXGridObject.prototype.kidsXmlFile = "";
dhtmlXGridObject.prototype.sortTreeRows = function (g, h, a) {
    var l = "getValue";
    if (this.cells5({ parentNode: { grid: this } }, this.getColType(g)).getDate) {
        l = "getDate";
        h = "str";
    }
    this.forEachRow(function (s) {

        var r = this._h2.get[s];
        if (!r) {
            return;
        }

        var o = this._get_cell_value(r.buff, g, l);
        if (h == "int") {
            r._sort = parseFloat(o);
            r._sort = isNaN(r._sort) ? -99999999999999 : r._sort;
        }
        else {
            r._sort = o;
        }
    });
    var e = this;
    var n = 1;
    var m = -1;
    if (a == "des") {
        n = -1;
        m = 1;
    }
    var c = null;
    if (typeof h == "function") {
        c = function (r, o) {
            return h(r._sort, o._sort, a, r.id, o.id);
        };
    }
    else {
        if (h == "cus") {
            c = function (r, o) {
                return e._customSorts[g](r._sort, o._sort, a, r.id, o.id);
            };
        }
        if (h == "str") {
            c = function (r, o) {
                return r._sort < o._sort ? m : r._sort == o._sort ? 0 : n;
            };
        }
        if (h == "int") {
            c = function (r, o) {
                return r._sort < o._sort ? m : r._sort == o._sort ? 0 : n;
            };
        }
        if (h == "date") {
            c = function (r, o) {
                return ((Date.parse(new Date(r._sort || "01/01/1900") + "") -
                    Date.parse(new Date(o._sort || "01/01/1900") + "")) *
                    n);
            };
        }
    }
    this._sortTreeRows(c, 0);
    this._renderSort(0, true);
    this.callEvent("onGridReconstructed", []);
};
dhtmlXGridObject.prototype._sortTreeRows = function (a, g) {
    var c = this._h2.get[g].childs;
    if (this.rowsCol.stablesort) {
        this.rowsCol.stablesort.call(c, a);
    }
    else {
        c.sort(a);
    }
    for (var e = 0; e < c.length; e++) {
        if (c[e].childs.length) {
            this._sortTreeRows(a, c[e].id);
        }
        c[e].index = e;
    }
};
dhtmlXGridObject.prototype._renderSort = function (e, c) {
    this._h2_to_buff();
    var a = this.objBox.scrollTop;
    this._reset_view();
    this.objBox.scrollTop = a;
};
dhtmlXGridObject.prototype._fixAlterCssTGR = function () {
    if (!this._realfake) {
        this._h2.forEachChild(0, function (a) {
            if (a.buff.tagName == "TR") {

                var c = (this._cssSP
                    ? a.level % 2
                    : a.index % 2)
                    ? this._cssUnEven
                    : this._cssEven;

                this.rowsAr[a.id].className =
                    c +
                        (this._cssSU ? " " + c + "_" + a.level : "") +
                        " " +
                        (this.rowsAr[a.id]._css || "") +
                        (this.rowsAr[a.id].className.indexOf("rowselected") != -1
                            ? " rowselected"
                            : "");
            }
        }, this);
    }
};
dhtmlXGridObject.prototype.moveRowUDTG = function (c, h) {
    var n = this._h2.get[c];
    var e = n.parent.childs[n.index + h];
    if (!e || e.parent != n.parent) {
        return;
    }
    var a = [n.state, e.state];
    this.collapseKids(this.rowsAr[n.id]);
    this.collapseKids(this.rowsAr[e.id]);
    var g = this.rowsCol._dhx_find(this.rowsAr[c]);
    var m = this.rowsBuffer._dhx_find(this.rowsAr[c]);
    var o = this.obj.rows[0].parentNode.removeChild(this.rowsCol[g]);
    var l = this.rowsCol[g + (h == 1 ? 2 : h)];
    if (l) {
        l.parentNode.insertBefore(o, l);
    }
    else {
        this.obj.rows[0].parentNode.appendChild(o);
    }
    this.rowsCol._dhx_swapItems(g, g + h);
    this.rowsBuffer._dhx_swapItems(m, m + h);
    this._h2.swap(e, n);
    if (a[0] == "minus") {
        this.expandKids(this.rowsAr[n.id]);
    }
    if (a[1] == "minus") {
        this.expandKids(this.rowsAr[e.id]);
    }
    this._fixAlterCss(Math.min(g, g + h));
};
dhtmlXGridObject.prototype._process_tree_xml = function (l, c) {
    this._parsing = true;
    var a = false;
    if (!c) {
        this.render_row = this.render_row_tree;
        a = true;
        c = l.getAttribute("parent") || 0;
        if (c == "0") {
            c = 0;
        }
        if (!this._h2) {
            this._h2 = this._createHierarchy();
        }
        if (this._fake) {
            this._fake._h2 = this._h2;
        }
    }
    var h = dhx4.ajax.xpath(this.xml.row, l);
    this._open = this._open || [];
    for (var e = 0; e < h.length; e++) {
        var n = h[e].getAttribute("id");
        if (!n) {
            n = this.uid();
            h[e].setAttribute("id", n);
        }
        var m = this._h2.add(n, c);
        m.buff = {
            idd: n,
            data: h[e],
            _parser: this._process_xml_row,
            _locator: this._get_xml_data
        };
        if (h[e].getAttribute("open")) {
            m.state = "minus";
            this._open.push(n);
        }
        this.rowsAr[n] = m.buff;
        this._process_tree_xml(h[e], n);
    }
    if (a) {
        var g = null;
        if (!h.length) {
            this._h2.change(c, "state", this._emptyLineImg);
        }
        else {
            if (c != 0 && !this._srnd) {
                this._h2.change(c, "state", "minus");
            }
        }
        for (var e_1 = 0; e_1 < this._open.length; e_1++) {
            g = this._h2.get[this._open[e_1]];
            if (!g.childs.length) {
                g.state = this._emptyLineImg;
            }
        }
        this._updateTGRState(this._h2.get[c]);
        this._h2_to_buff();
        if (c != 0 && this._srnd) {
            this.openItem(c);
        }
        else {
            if (this.pagingOn) {
                this._renderSort();
            }
            else {
                this.render_dataset();
            }
        }
        if (this.kidsXmlFile) {
            for (var e_2 = 0; e_2 < this._open.length; e_2++) {
                g = this._h2.get[this._open[e_2]];
                if (g._xml_await) {
                    this.expandKids({ idd: g.id });
                }
            }
        }
        this._open = [];
        if (this._slowParse === false) {
            this.forEachRow(function (o) {

                this.render_row_tree(0, o);
            });
        }
        this._parsing = false;
        if (c != 0 && !this._srnd) {
            this.callEvent("onOpenEnd", [c, 1]);
        }
    }
};
dhtmlXGridObject.prototype._h2_to_buff = function (c) {
    if (!c) {
        c = this._h2.get[0];
        this.rowsBuffer = new dhtmlxArray();
        if (this._fake && !this._realfake) {
            this._fake.rowsBuffer = this.rowsBuffer;
        }
    }
    for (var a = 0; a < c.childs.length; a++) {
        this.rowsBuffer.push(c.childs[a].buff);
        if (c.childs[a].state == "minus") {
            this._h2_to_buff(c.childs[a]);
        }
    }
};
dhtmlXGridObject.prototype.render_row_tree = function (c, g) {
    var a = null;
    if (g) {
        a = this._h2.get[g];
        a = a ? a.buff : a;
    }
    else {
        a = this.rowsBuffer[c];
    }
    if (!a) {
        return -1;
    }
    if (a._parser) {
        if (this.rowsAr[a.idd] && this.rowsAr[a.idd].tagName == "TR") {
            return (this._h2.get[a.idd].buff = this.rowsBuffer[c] = this.rowsAr[a.idd]);
        }
        var e = this._prepareRow(a.idd);
        this.rowsAr[a.idd] = e;
        if (!g) {
            this.rowsBuffer[c] = e;
        }
        this._h2.get[a.idd].buff = e;
        a._parser.call(this, e, a.data);
        this._postRowProcessing(e);
        return e;
    }
    return a;
};
dhtmlXGridObject.prototype._removeTrGrRow = function (g, cObj) {
    if (cObj) {
        this._h2.forEachChild(cObj.id, function (l) {

            this._removeTrGrRow(null, l);

            delete this.rowsAr[l.id];
        }, this);
        return;
    }
    var h = this.getRowIndex(g.idd);
    var c = this._h2.get[g.idd];
    if (h != -1 && h !== this.undefined) {
        var a = 1;
        if (c && c.state == "minus") {
            a += this._getOpenLenght(c.id, 0);
        }
        for (var e = 0; e < a; e++) {
            if (this.rowsCol[e + h]) {
                this.rowsCol[e + h].parentNode.removeChild(this.rowsCol[e + h]);
            }
        }
        if (this._fake) {
            for (var e_3 = 0; e_3 < a; e_3++) {
                if (this._fake.rowsCol[e_3 + h]) {
                    this._fake.rowsCol[e_3 + h].parentNode.removeChild(this._fake.rowsCol[e_3 + h]);
                }
            }
            if (a > 1) {
                this._fake.rowsCol.splice(h + 1, a - 1);
            }
        }
        this.rowsCol.splice(h, a);
        this.rowsBuffer.splice(h, a);
    }
    if (!c) {
        return;
    }
    this._removeTrGrRow(null, c);
    delete this.rowsAr[c.id];
    if (c.parent.childs.length == 1) {
        this._h2.change(c.parent.id, "state", this._emptyLineImg);
        this._updateTGRState(c.parent);
    }
    this._h2.remove(c.id);
};
dhtmlXGridObject.prototype.openItem = function (c) {
    var e = this._h2.get[c || 0];
    var a = this.getRowById(c || 0);
    if (!a) {
        return;
    }
    if (e.parent && e.parent.id != 0) {
        this.openItem(e.parent.id);
    }
    this.expandKids(a);
};
/**
 * TreeGrid 启用智能XML分析模式
 * @param a
 */
dhtmlXGridObject.prototype.enableSmartXMLParsing = function (a) {
    this._slowParse = dhx4.s2b(a);
};
dhtmlXGridObject.prototype._copyTreeGridRowContent = function (a, c, e) {
    var g = this.cellType._dhx_find("tree");
    for (var i = 0; i < a.cells.length; i++) {
        if (i != g) {
            this.cells(e, i).setValue(this.cells(c, i).getValue());
        }
        else {
            this.cells(e, i).setValueA(this.cells(c, i).getValue());
        }
    }
};
/**
 * 根据行id 关闭行记录
 * @param rowId
 */
dhtmlXGridObject.prototype.closeItem = function (rowId) {
    var a = this.getRowById(rowId);
    if (!a) {
        return;
    }
    this.collapseKids(a);
};
/**
 * 删除相关行的所有子级
 * @param rowId
 */
dhtmlXGridObject.prototype.deleteChildItems = function (rowId) {
    var c = this._h2.get[rowId];
    if (!c) {
        return;
    }
    while (c.childs.length) {
        this.deleteRow(c.childs[0].id);
    }
};
/**
 * 获取所有嵌套行的ID列表
 * @param c
 */
dhtmlXGridObject.prototype.getAllSubItems = function (rowId) {
    var g = [];
    var e = this._h2.get[rowId || 0];
    if (e) {
        for (var a = 0; a < e.childs.length; a++) {
            g.push(e.childs[a].id);
            if (e.childs[a].childs.length) {
                g = g.concat(this.getAllSubItems(e.childs[a].id).split(this.delim));
            }
        }
    }
    return g.join(this.delim);
};
/**
 * 获取指定位置中子项的ID
 * @param rowId
 * @param ind
 */
dhtmlXGridObject.prototype.getChildItemIdByIndex = function (rowId, ind) {
    var e = this._h2.get[rowId || 0];
    if (!e) {
        return null;
    }
    return e.childs[ind] ? e.childs[ind].id : null;
};
/**
 * 获取树列的真实标题
 * @param a
 */
dhtmlXGridObject.prototype.getItemText = function (rowId) {
    return this.cells(rowId, this.cellType._dhx_find("tree")).getLabel();
};
/**
 * 返回行的打开/关闭状态
 * @param a
 */
dhtmlXGridObject.prototype.getOpenState = function (rowId) {
    var c = this._h2.get[rowId || 0];
    if (!c) {
        return;
    }
    if (c.state == "minus") {
        return true;
    }
    return false;
};
/**
 * 返回父行的ID
 * @param rowId
 */
dhtmlXGridObject.prototype.getParentId = function (rowId) {
    var c = this._h2.get[rowId || 0];
    if (!c || !c.parent) {
        return null;
    }
    return c.parent.id;
};
/**
 * 返回用逗号分隔的子行ID列表
 * @param rowId
 */
dhtmlXGridObject.prototype.getSubItems = function (rowId) {
    var g = [];
    var e = this._h2.get[rowId || 0];
    if (e) {
        for (var a = 0; a < e.childs.length; a++) {
            g.push(e.childs[a].id);
        }
    }
    return g.join(this.delim);
};
dhtmlXGridObject.prototype.expandAll = function (a) {
    this._renderAllExpand(a || 0);
    this._h2_to_buff();
    this._reset_view();
    this.setSizes();
    this.callEvent("onGridReconstructed", []);
    if (this._redrawLines) {
        this._redrawLines();
    }
};
dhtmlXGridObject.prototype._renderAllExpand = function (e) {
    var a = this._h2.get[e].childs;
    for (var c = 0; c < a.length; c++) {
        if (a[c].childs.length) {
            this._h2.change(a[c].id, "state", "minus");
            this._updateTGRState(a[c]);
            this._renderAllExpand(a[c].id);
        }
    }
};
dhtmlXGridObject.prototype.collapseAll = function (a) {
    this._h2.forEachChild(a || 0, function (c) {
        if (c && c.state == "minus") {
            c.state = "plus";
            c.update = true;

            this._updateTGRState(c);
        }
    }, this);
    this._h2_to_buff();
    this._reset_view();
    this.setSizes();
    this.callEvent("onGridReconstructed", []);
    if (this._redrawLines) {
        this._redrawLines();
    }
};
dhtmlXGridObject.prototype.hasChildren = function (c) {
    var a = this._h2.get[c];
    if (a && a.childs.length) {
        return a.childs.length;
    }
    if (a._xml_await) {
        return -1;
    }
    return 0;
};
dhtmlXGridObject.prototype.setItemCloseable = function (e, c) {
    var a = this._h2.get[e];
    if (!a) {
        return;
    }
    a._closeable = !dhx4.s2b(c);
};
dhtmlXGridObject.prototype.setItemText = function (a, c) {
    return this.cells(a, this.cellType._dhx_find("tree")).setLabel(c);
};
dhtmlXGridObject.prototype.setItemImage = function (c, a) {
    this._h2.get[c].image = a;
    this.rowsAr[c].imgTag.nextSibling.src = (this.iconURL || "") + a;
};
dhtmlXGridObject.prototype.setItemIcon = function (c, a) {
    this._h2.get[c].icon = a;
    this.rowsAr[c].imgTag.nextSibling.className = "dhx_treegrid_icon fa fa-" + a;
};
dhtmlXGridObject.prototype.getItemImage = function (a) {
    this.getRowById(a);
    return this._h2.get[a].image;
};
dhtmlXGridObject.prototype.getItemIcon = function (a) {
    this.getRowById(a);
    return this._h2.get[a].icon;
};
dhtmlXGridObject.prototype.setImageSize = function (c, a) {
    this._img_width = c;
    this._img_height = a;
};
dhtmlXGridObject.prototype._getRowImage = function (a) {
    return this._h2.get[a.idd].image;
};
dhtmlXGridObject.prototype.setOnOpenStartHandler = function (a) {
    this.attachEvent("onOpenStart", a);
};
dhtmlXGridObject.prototype.setOnOpenEndHandler = function (a) {
    this.attachEvent("onOpenEnd", a);
};
dhtmlXGridObject.prototype.enableTreeCellEdit = function (a) {
    this._edtc = !dhx4.s2b(a);
};
dhtmlXGridObject.prototype.getLevel = function (a) {
    var c = this._h2.get[a || 0];
    if (!c) {
        return -1;
    }
    return c.level;
};
dhtmlXGridObject.prototype._fixHiddenRowsAllTG = function (c, a) {
    for (var i in this.rowsAr) {
        if (this.rowsAr[i] && this.rowsAr[i].childNodes) {
            this.rowsAr[i].childNodes[c].style.display = a;
        }
    }
};
dhtmlXGridObject.prototype._updateLine = function (e, c) {
    c = c || this.rowsAr[e.id];
    if (!c) {
        return;
    }
    var a = c.imgTag;
    if (!a) {
        return;
    }
    if (e.state == "blank") {
        return (a.src = this.iconTree + "blank.gif");
    }
    var g = 1;
    if (e.index == 0) {
        if (e.level == 0) {
            if (e.parent.childs.length - 1 > e.index) {
                g = 3;
            }
            else {
                g = 1;
            }
        }
        else {
            if (e.parent.childs.length - 1 > e.index) {
                g = 3;
            }
            else {
                g = 2;
            }
        }
    }
    else {
        if (e.parent.childs.length - 1 > e.index) {
            g = 3;
        }
        else {
            g = 2;
        }
    }
    a.src = this.iconTree + e.state + g + ".gif";
};
dhtmlXGridObject.prototype._updateParentLine = function (g, e) {
    e = e || this.rowsAr[g.id];
    if (!e) {
        return;
    }
    var a = e.imgTag;
    if (!a) {
        return;
    }
    for (var c = g.level; c > 0; c--) {
        if (g.id == 0) {
            break;
        }
        a = a.previousSibling;
        g = g.parent;
        if (g.parent.childs.length - 1 > g.index) {
            a.src = this.iconTree + "line1.gif";
        }
        else {
            a.src = this.iconTree + "blank.gif";
        }
    }
};
dhtmlXGridObject.prototype._renderSortA = dhtmlXGridObject.prototype._renderSort;
dhtmlXGridObject.prototype._renderSort = function () {
    this._renderSortA.apply(this, arguments);
    this._redrawLines(0);
};
dhtmlXGridObject.prototype._redrawLines = function (a) {
    if (this._tgle) {
        this._h2.forEachChild(a || 0, function (c) {

            this._updateLine(c);

            this._updateParentLine(c);
        }, this);
    }
};
dhtmlXGridObject.prototype.enableTreeGridLines = function () {
    this._emptyLineImg = "line";
    this._updateTGRState = function (c, a) {
        if (a || !c.update || c.id == 0) {
            return;
        }
        if (this._tgle) {
            this._updateLine(c, this.rowsAr[c.id]);
        }
        c.update = false;
    };
    this._tgle = true;
    this.attachEvent("onXLE", function (e, c, g) {

        this._redrawLines(g);
    });
    this.attachEvent("onOpenEnd", function (a) {

        this._redrawLines(a);
    });
    this.attachEvent("onRowAdded", function (c) {

        var a = this._h2.get[c];

        this._updateLine(a);

        this._updateParentLine(a);
        if (a.index < a.parent.childs.length - 1) {
            a = a.parent.childs[a.index + 1];

            this._updateLine(a);

            this._updateParentLine(a);
        }
        else {
            if (a.index != 0) {
                a = a.parent.childs[a.index - 1];

                this._updateLine(a);

                this._updateParentLine(a);
                if (a.childs.length) {

                    this._h2.forEachChild(a.id, function (e) {

                        this._updateParentLine(e);

                    }, this);
                }
            }
        }
    });
    this.attachEvent("onOpen", function (g, c) {
        if (c) {

            var e = this._h2.get[g];
            for (var a = 0; a < e.childs.length; a++) {

                this._updateParentLine(e.childs[a]);
            }
        }
        return true;
    });
    this.attachEvent("onBeforeRowDeleted", function (g) {

        var c = this;

        var e = this._h2.get[g];
        var a = null;
        if (e.index != 0) {
            a = e.parent.childs[e.index - 1];
        }
        e = e.parent;
        window.setTimeout(function () {
            e = c._h2.get[e.id];
            if (!e) {
                return;
            }
            c._updateLine(e);
            c._updateParentLine(e);
            if (a) {
                c._updateLine(a);
                if (a.state == "minus") {
                    c._h2.forEachChild(a.id, function (h) {
                        c._updateParentLine(h);
                    }, c);
                }
            }
        }, 1);
        return true;
    });
};
dhtmlXGridObject.prototype.setFiltrationLevel = function (e, a, c) {
    this._tr_strfltr = e;
    this._tr_fltr_c = a;
    this._tr_fltr_d = c;
    this.refreshFilters();
};
dhtmlXGridObject.prototype.filterTreeBy = function (g, h, e) {
    var a = this._h2;
    if (typeof this._tr_strfltr == "undefined") {
        this._tr_strfltr = -1;
    }
    if (this._f_rowsBuffer) {
        if (!e) {
            this._h2 = this._f_rowsBuffer;
            if (this._fake) {
                this._fake._h2 = this._h2;
            }
        }
    }
    else {
        this._f_rowsBuffer = this._h2;
    }
    var l = true;
    this.dma(true);
    this._fbf = {};
    if (typeof g == "object") {
        for (var c = 0; c < h.length; c++) {
            this._filterTreeA(g[c], h[c]);
        }
    }
    else {
        this._filterTreeA(g, h);
    }
    this._fbf = null;
    this.dma(false);
    this._fix_filtered_images(this._h2, a);
    this._renderSort();
    this.callEvent("onGridReconstructed", []);
};
dhtmlXGridObject.prototype._filterTreeA = function (e, o) {
    if (o == "") {
        return;
    }
    var m = true;
    if (typeof o == "function") {
        m = false;
    }
    else {
        o = (o || "").toString().toLowerCase();
    }
    var c = function (w, v, uEl) {
        var x = uEl.get[w.parent.id];
        if (!x) {
            x = c(w.parent, v, uEl);
        }
        var u = r.get[w.id];
        if (!u) {
            u = {
                id: w.id,
                childs: [],
                level: w.level,
                parent: x,
                index: x.childs.length,
                image: w.image,
                state: w.state,
                buff: w.buff,
                has_kids: w.has_kids,
                _xml_await: w._xml_await
            };
            x.childs.push(u);
            r.get[u.id] = u;
        }
        return u;
    };
    var n = this._fbf;
    var r = this._createHierarchy();
    var a;
    var h = this._tr_strfltr;
    var l = this;
    var g = function (u) {
        for (var s = 0; s < u.childs.length; s++) {
            l.temp(u.childs[s]);
        }
    };
    switch (h.toString()) {
        case "-2":
            a = function (s) {
                if (n[s.id]) {
                    return false;
                }
                g(s);
                return true;
            };
            break;
        case "-1":
            a = function (s) {
                return !s.childs.length;
            };
            break;
        default:
            a = function (s) {
                return h == s.level;
            };
            break;
    }
    this.temp = function (s) {
        if (s.id != 0 && a(s)) {
            if (m
                ? this._get_cell_value(s.buff, e)
                    .toString()
                    .toLowerCase()
                    .indexOf(o) == -1
                : !o(this._get_cell_value(s.buff, e), s.id)) {
                n[s.id] = true;
                if (this._tr_fltr_c) {
                    c(s.parent, this._h2, r);
                }
                return false;
            }
            else {
                c(s, this._h2, r);
                if (s.childs && h != -2) {
                    this._h2.forEachChild(s.id, function (u) {

                        c(u, this._h2, r);
                    }, this);
                }
                return true;
            }
        }
        else {
            if (this._tr_fltr_d && this._tr_strfltr > s.level && s.id != 0) {
                c(s, this._h2, r);
            }
            g(s);
        }
    };
    this.temp(this._h2.get[0]);
    this._h2 = r;
    if (this._fake) {
        this._fake._h2 = this._h2;
    }
};
dhtmlXGridObject.prototype._fix_filtered_images = function (c, a) {
    c.forEachChild(0, function (e) {
        if (!e.childs.length && !e.has_kids) {

            if (e.state != this._emptyLineImg) {

                e.state = this._emptyLineImg;
                e.update = true;

                this._updateTGRState(e);
            }
        }
        else {
            if (e.buff.tagName == "TR") {
                var g = a.get[e.id];

                if (g && g.state != this._emptyLineImg) {
                    e.state = g.state;
                }
                e.update = true;

                this._updateTGRState(e);
            }
        }
    }, this);
};
dhtmlXGridObject.prototype.collectTreeValues = function (e) {
    if (typeof this._tr_strfltr == "undefined") {
        this._tr_strfltr = -1;
    }
    this.dma(true);
    this._build_m_order();
    e = this._m_order ? this._m_order[e] : e;
    var m = {};
    var h = [];
    var a = this._f_rowsBuffer || this._h2;
    a.forEachChild(0, function (c) {

        if (this._tr_strfltr == -2 ||

            (this._tr_strfltr == -1 && !c.childs.length) ||
            this._tr_strfltr == c.level) {

            var n = this._get_cell_value(c.buff, e);
            if (n) {
                m[n] = true;
            }
        }
    }, this);
    this.dma(false);
    var g = this.combos[e];
    for (var l in m) {
        if (m[l] === true) {
            h.push(g ? g.get(l) || l : l);
        }
    }
    return h.sort();
};
dhtmlXGridObject.prototype._in_header_stat_tree_total = function (e, a, h) {
    var g = function () {
        var l = 0;

        this._build_m_order();

        var c = this._m_order ? this._m_order[a] : a;

        this._h2.forEachChild(0, function (n) {

            var m = parseFloat(this._get_cell_value(n.buff || this.rowsAr[n.id], c));
            l += isNaN(m) ? 0 : m;

        }, this);

        return this._maskArr[a] ? this._aplNF(l, a) : Math.round(l * 100) / 100;
    };
    this._stat_in_header(e, g, a, h, h);
};
dhtmlXGridObject.prototype._in_header_stat_tree_total_leaf = function (e, a, h) {
    var g = function () {
        var l = 0;

        this._build_m_order();

        var c = this._m_order ? this._m_order[a] : a;

        this._h2.forEachChild(0, function (n) {
            if (n.childs.length) {
                return;
            }

            var m = parseFloat(this._get_cell_value(n.buff || this.rowsAr[n.id], c));
            l += isNaN(m) ? 0 : m;

        }, this);

        return this._maskArr[a] ? this._aplNF(l, a) : Math.round(l * 100) / 100;
    };
    this._stat_in_header(e, g, a, h, h);
};
dhtmlXGridObject.prototype._in_header_stat_tree_multi_total = function (e, a, l) {
    var h = l[1].split(":");
    l[1] = "";
    var g = function () {
        var c = 0;

        this._h2.forEachChild(0, function (n) {

            var m = parseFloat(this._get_cell_value(n.buff || this.rowsAr[n.id], h[0])) *
                parseFloat(this._get_cell_value(n.buff || this.rowsAr[n.id], h[1]));
            c += isNaN(m) ? 0 : m;

        }, this);

        return this._maskArr[a] ? this._aplNF(c, a) : Math.round(c * 100) / 100;
    };
    this._stat_in_header(e, g, a, l, l);
};
dhtmlXGridObject.prototype._in_header_stat_tree_multi_total_leaf = function (e, a, l) {
    var h = l[1].split(":");
    l[1] = "";
    var g = function () {
        var c = 0;

        this._h2.forEachChild(0, function (n) {
            if (n.childs.length) {
                return;
            }

            var m = parseFloat(this._get_cell_value(n.buff || this.rowsAr[n.id], h[0])) *
                parseFloat(this._get_cell_value(n.buff || this.rowsAr[n.id], h[1]));
            c += isNaN(m) ? 0 : m;

        }, this);

        return this._maskArr[a] ? this._aplNF(c, a) : Math.round(c * 100) / 100;
    };
    this._stat_in_header(e, g, a, l, l);
};
dhtmlXGridObject.prototype._in_header_stat_tree_max = function (e, a, h) {
    var g = function () {
        var l = -999999999;

        this._build_m_order();

        var c = this._m_order ? this._m_order[a] : a;

        if (this.getRowsNum() == 0) {
            return "";
        }

        this._h2.forEachChild(0, function (m) {

            var n = parseFloat(this._get_cell_value(m.buff || this.rowsAr[m.id], c));
            if (!isNaN(n)) {
                l = Math.max(l, n);
            }

        }, this);

        return this._maskArr[a] ? this._aplNF(l, a) : l;
    };
    this._stat_in_header(e, g, a, h);
};
dhtmlXGridObject.prototype._in_header_stat_tree_min = function (e, a, h) {
    var g = function () {
        var l = 999999999;

        this._build_m_order();

        var c = this._m_order ? this._m_order[a] : a;

        if (this.getRowsNum() == 0) {
            return "";
        }

        this._h2.forEachChild(0, function (m) {

            var n = parseFloat(this._get_cell_value(m.buff || this.rowsAr[m.id], c));
            if (!isNaN(n)) {
                l = Math.min(l, n);
            }

        }, this);

        return this._maskArr[a] ? this._aplNF(l, a) : l;
    };
    this._stat_in_header(e, g, a, h);
};
dhtmlXGridObject.prototype._in_header_stat_tree_average = function (e, a, h) {
    var g = function () {
        var m = 0;
        var l = 0;

        this._build_m_order();

        var c = this._m_order ? this._m_order[a] : a;

        this._h2.forEachChild(0, function (o) {

            var n = parseFloat(this._get_cell_value(o.buff || this.rowsAr[o.id], c));
            m += isNaN(n) ? 0 : n;
            l++;

        }, this);

        return this._maskArr[a]
            ? this._aplNF(m, a)
            : Math.round((m / l) * 100) / 100;
    };
    this._stat_in_header(e, g, a, h);
};
dhtmlXGridObject.prototype._in_header_stat_tree_max_leaf = function (e, a, h) {
    var g = function () {
        var l = -999999999;

        this._build_m_order();

        var c = this._m_order ? this._m_order[a] : a;

        if (this.getRowsNum() == 0) {
            return "";
        }

        this._h2.forEachChild(0, function (m) {
            if (m.childs.length) {
                return;
            }

            var n = parseFloat(this._get_cell_value(m.buff || this.rowsAr[m.id], c));
            if (!isNaN(n)) {
                l = Math.max(l, n);
            }

        }, this);

        return this._maskArr[a] ? this._aplNF(l, a) : l;
    };
    this._stat_in_header(e, g, a, h);
};
dhtmlXGridObject.prototype._in_header_stat_tree_min_leaf = function (e, a, h) {
    var g = function () {
        var l = 999999999;

        this._build_m_order();

        var c = this._m_order ? this._m_order[a] : a;

        if (this.getRowsNum() == 0) {
            return "";
        }

        this._h2.forEachChild(0, function (m) {
            if (m.childs.length) {
                return;
            }

            var n = parseFloat(this._get_cell_value(m.buff || this.rowsAr[m.id], c));
            if (!isNaN(n)) {
                l = Math.min(l, n);
            }

        }, this);

        return this._maskArr[a] ? this._aplNF(l, a) : l;
    };
    this._stat_in_header(e, g, a, h);
};
dhtmlXGridObject.prototype._in_header_stat_tree_average_leaf = function (e, a, h) {
    var g = function () {
        var m = 0;
        var l = 0;

        this._build_m_order();

        var c = this._m_order ? this._m_order[a] : a;

        this._h2.forEachChild(0, function (o) {
            if (o.childs.length) {
                return;
            }

            var n = parseFloat(this._get_cell_value(o.buff || this.rowsAr[o.id], c));
            m += isNaN(n) ? 0 : n;
            l++;

        }, this);

        return this._maskArr[a]
            ?
                this._aplNF(m, a)
            : Math.round((m / l) * 100) / 100;
    };
    this._stat_in_header(e, g, a, h);
};
dhtmlXGridObject.prototype._in_header_stat_tree_count = function (e, a, h) {
    var g = function () {
        var c = 0;

        this._h2.forEachChild(0, function (l) {
            c++;

        }, this);
        return c;
    };
    this._stat_in_header(e, g, a, h);
};
dhtmlXGridObject.prototype._in_header_stat_tree_count_leaf = function (e, a, h) {
    var g = function () {
        var c = 0;

        this._h2.forEachChild(0, function (l) {
            if (!l.childs.length) {
                c++;
            }

        }, this);
        return c;
    };
    this._stat_in_header(e, g, a, h);
};
dhtmlXGridObject.prototype._stat_in_header = function (e, g, a, m) {
    var h = this;
    var l = function () {

        this.dma(true);

        e.innerHTML = (m[0] ? m[0] : "") + g.call(this) + (m[1] ? m[1] : "");

        this.dma(false);

        this.callEvent("onStatReady", []);
    };
    if (!this._stat_events) {
        this._stat_events = [];
        this.attachEvent("onClearAll", function () {

            if (!this.hdr.rows[1]) {

                for (var n = 0; n < this._stat_events.length; n++) {
                    for (var c = 0; c < 4; c++) {

                        this.detachEvent(this._stat_events[n][c]);
                    }
                }

                this._stat_events = [];
            }
        });
    }
    this._stat_events.push([
        this.attachEvent("onGridReconstructed", l),
        this.attachEvent("onXLE", l),
        this.attachEvent("onFilterEnd", l),
        this.attachEvent("onEditCell", function (c, o, n) {
            if (c == 2 && n == a) {

                l.call(this);
            }
            return true;
        })
    ]);
    e.innerHTML = "";
};
dhtmlXGridObject.prototype._build_m_order = function () {
    if (this._c_order) {
        this._m_order = [];
        for (var a = 0; a < this._c_order.length; a++) {
            this._m_order[this._c_order[a]] = a;
        }
    }
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/dxGridMethods3.js